<template>
    <div class="m-0">
        <validation-provider
                :name="field.name"
                :rules="field.rules"
                v-slot="validationContext"
        >
            <b-form-group
                    :label-for="field.name"
                    :id="'g_' + field.name"
            >
                <b-form-checkbox
                        v-model="data.value"
                        value=1
                        unchecked-value=0
                        :id="field.name"
                        :state="getValidationState(validationContext)"
                        :aria-describedby="'input-2-live-feedback' + field.name"
                        :disabled="field.readonly"
                >
                    {{field.label}}
                </b-form-checkbox>
                <small v-if="field.hint" class="text-info">{{field.hint}}</small>
                <h6 class="text-right ">&#8288;</h6>
                <b-form-invalid-feedback
                        :id="'input-2-live-feedback' + field.name"
                >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
            </b-form-group>
        </validation-provider>
    </div>
</template>

<script>
    export default {
        name: "CheckboxInput",
        props: {
            field: { required: true},
            data: { required: true }
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
        }
    }
</script>

<style scoped>

</style>
